import React from "react";

// compoenents
import BasePage from "../../../UI/BasePage/BasePage";
import Aux from "../../../hoc/Aux";
import {
  CardSection,
  Container
} from "../../../UI/ContentSection/ContentSection";

// content
import VisionPerfectFit from "./Content/VisionPerfectFit";
import VisionQuality from "./Content/VisionQuality";
import VisionSustainability from "./Content/VisionSustainability";
import VisionIndividuality from "./Content/VisionIndividuality";

//images
import visionImg from "../../../assests/images/vision.png";

const Vision = () => {
  return (
    <Aux>
      <BasePage
        title={"THE VISION"}
        image={visionImg}
        textLineOne={"OUR MISSION IS TO PROVIDE A NEW ACCESS TO FASHION WHERE"}
        textLineTwo={"FIT. QUALITY. INDIVIDUALITY. SUSTAINABILITY."}
        textLineThree={
          "MATTER MORE THAN AN EXPENSIVE BRAND WITHOUT TRUE SUBSTANCE."
        }
      />
      <CardSection>
        <Container>
          <VisionPerfectFit />
          <VisionQuality />
          <VisionSustainability />
          <VisionIndividuality />
        </Container>
      </CardSection>
    </Aux>
  );
};

export default Vision;



// WEBPACK FOOTER //
// ./src/components/Pages/Vision/Vision.js